import { render, staticRenderFns } from "./AdminFlock.vue?vue&type=template&id=1f33dfb0&scoped=true&"
import script from "./AdminFlock.vue?vue&type=script&lang=js&"
export * from "./AdminFlock.vue?vue&type=script&lang=js&"
import style0 from "./AdminFlock.vue?vue&type=style&index=0&id=1f33dfb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f33dfb0",
  null
  
)

export default component.exports